import { isLive } from '@utils/env';

export const PLATFORM_LOAD_HANG_QUERY_VALUE = '10';
export const PLATFORM_LOAD_HANG_TIMEOUT_MS = 10000;

function getHangQueryValue(route) {
    if (route?.query && Object.prototype.hasOwnProperty.call(route.query, 'hang')) {
        return route.query.hang;
    }

    if (typeof window !== 'undefined' && window.location?.search) {
        return new URLSearchParams(window.location.search).get('hang');
    }

    return null;
}

export function isPlatformLoadHangEnabled(route = null) {
    if (isLive()) {
        return false;
    }

    const hang = getHangQueryValue(route);

    return hang === PLATFORM_LOAD_HANG_QUERY_VALUE || hang === 10;
}

export function getPlatformLoadTimeoutMs(route, defaultTimeoutMs) {
    if (isPlatformLoadHangEnabled(route)) {
        return PLATFORM_LOAD_HANG_TIMEOUT_MS;
    }

    return defaultTimeoutMs;
}
